module.exports = function getResource(label, vars = []) {
    let resources = {
        paypalAccount: 'Compte PayPal',
        removePaypal: 'Supprimer PayPal'
    };

    return resources[label];
};
